// extracted by css-extract-rspack-plugin
export default {"cls1":"CitationModal-cls1_44m","cls2":"CitationModal-cls2_HQe CitationModal-cls1_44m"};